import { ApiFactory } from './Api';

const api = new ApiFactory();

async function getPublicNotices() {
    const response = await api.get(`/notices/public`);
    return response.data;
}

async function getNotice(noticeId) {
    const response = await api.get(`/notices/${noticeId}`);
    return response.data;
}

async function getUnreadNotice() {
    const response = await api.get(`/notices/unread-count`);
    // API return `{ data: { count } }`
    return response?.data ?? response;
}

async function markNoticeAsRead(noticeId) {
    const response = await api.post(`/notices/read`, {
        noticeId
    });
    return response.data;
}

async function getOpenNotices() {
    const response = await api.get(`/notices/open`);
    return response.data;
}

export { getPublicNotices, getNotice, getUnreadNotice, markNoticeAsRead, getOpenNotices };
